module.exports = __webpack_public_path__ + "img/hk-ict-awards-2020-silver.10b087cf.jpg";